import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgUkraineHeart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8543_44628)",
		children: [
			/* @__PURE__ */ _jsxs("mask", {
				id: "mask0_8543_44628",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 3,
				width: 24,
				height: 18,
				children: [
					/* @__PURE__ */ _jsx("mask", {
						id: "path-2-inside-1_8543_44628",
						fill: "white",
						children: /* @__PURE__ */ _jsx("path", { d: "M23.0121 6.82494C20.6121 0.449948 12.8121 3.29994 12.0996 6.48744C11.1246 3.11244 3.51211 0.599948 1.18712 6.82494C-1.40038 13.7624 11.1996 19.9874 12.0996 20.9999C12.9996 20.1749 25.5996 13.6499 23.0121 6.82494" })
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.0121 6.82494C20.6121 0.449948 12.8121 3.29994 12.0996 6.48744C11.1246 3.11244 3.51211 0.599948 1.18712 6.82494C-1.40038 13.7624 11.1996 19.9874 12.0996 20.9999C12.9996 20.1749 25.5996 13.6499 23.0121 6.82494",
						fill: "#3E4347"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M12.0996 6.48744L10.1782 7.04252L14.0514 6.92373L12.0996 6.48744ZM1.18712 6.82494L-0.686465 6.12517L-0.686784 6.12603L1.18712 6.82494ZM12.0996 20.9999L10.6048 22.3286L11.954 23.8465L13.451 22.4742L12.0996 20.9999ZM24.8838 6.12028C24.1314 4.12173 22.89 2.70381 21.3404 1.87223C19.8186 1.0556 18.1556 0.886822 16.6569 1.08805C15.165 1.28836 13.743 1.86521 12.6113 2.6672C11.5177 3.44222 10.4738 4.5926 10.1478 6.05115L14.0514 6.92373C14.0816 6.78853 14.2799 6.38735 14.9242 5.93073C15.5304 5.50109 16.342 5.16621 17.1892 5.05247C18.0295 4.93963 18.811 5.05445 19.449 5.3968C20.0591 5.7242 20.6927 6.34065 21.1403 7.5296L24.8838 6.12028ZM14.021 5.93236C13.6095 4.50799 12.5761 3.37556 11.447 2.59548C10.2946 1.79929 8.86938 1.24438 7.38282 1.06984C5.88943 0.894504 4.25213 1.09601 2.764 1.92348C1.25141 2.76455 0.0439242 4.16961 -0.686464 6.12517L3.0607 7.52471C3.49281 6.36777 4.10875 5.75252 4.70788 5.41937C5.33146 5.07263 6.09416 4.94601 6.91639 5.04255C7.74545 5.13989 8.55152 5.45685 9.17331 5.88643C9.81843 6.33214 10.1022 6.77939 10.1782 7.04252L14.021 5.93236ZM-0.686784 6.12603C-1.58392 8.53139 -1.11564 10.8238 -0.0946461 12.7578C0.902783 14.6473 2.47213 16.2978 4.02486 17.645C5.59445 19.0068 7.25956 20.1536 8.55121 21.004C8.87534 21.2174 9.17861 21.4138 9.45029 21.5896C9.72507 21.7673 9.96149 21.92 10.1651 22.0543C10.3715 22.1904 10.5199 22.2917 10.6218 22.366C10.7615 22.4679 10.7055 22.4419 10.6048 22.3286L13.5944 19.6712C13.3812 19.4314 13.1212 19.2381 12.9788 19.1342C12.7985 19.0027 12.5864 18.8596 12.3672 18.715C12.1452 18.5687 11.8909 18.4044 11.6229 18.231C11.3518 18.0557 11.0603 17.8668 10.7507 17.663C9.50762 16.8446 8.0157 15.8118 6.64623 14.6236C5.25991 13.4208 4.10816 12.151 3.44271 10.8905C2.80081 9.67453 2.66441 8.58724 3.06102 7.52385L-0.686784 6.12603ZM13.451 22.4742C13.381 22.5384 13.3626 22.5417 13.5141 22.44C13.6321 22.3607 13.793 22.2572 14.0064 22.1215C14.4218 21.8572 14.9972 21.4957 15.648 21.0673C16.9498 20.2102 18.6154 19.0456 20.1852 17.6636C21.7378 16.2967 23.3022 14.6265 24.2961 12.7324C25.3106 10.7993 25.7876 8.50422 24.8822 6.11594L21.142 7.53394C21.5303 8.55815 21.4026 9.63805 20.7542 10.8737C20.0853 12.1484 18.9285 13.4407 17.5421 14.6613C16.1728 15.8668 14.6814 16.9146 13.4485 17.7263C12.8318 18.1323 12.2954 18.4692 11.8597 18.7463C11.6474 18.8813 11.4479 19.0092 11.2837 19.1195C11.153 19.2073 10.9307 19.3583 10.7481 19.5256L13.451 22.4742Z",
						fill: "white",
						mask: "url(#path-2-inside-1_8543_44628)"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_8543_44628)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: .100098,
					y: 610352e-10,
					width: 27.4179,
					height: 13.0075,
					fill: "#0057B7"
				}), /* @__PURE__ */ _jsx("rect", {
					x: .100098,
					y: 11.9999,
					width: 27.4179,
					height: 13.0075,
					fill: "#FFD500"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2745 6.81969C20.8745 0.444699 13.0745 3.29469 12.362 6.48219C11.3871 3.10719 3.77456 0.594699 1.44957 6.81969C-1.13793 13.7572 11.462 19.9822 12.362 20.9947C13.262 20.1697 25.862 13.6447 23.2745 6.81969",
				stroke: "white",
				strokeWidth: 1.6
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8543_44628",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.5 0H24.5V24H0.5V0Z",
			fill: "white"
		})
	}) })]
});
export default SvgUkraineHeart;
